Postlogin.Lesson = (function (my) {
    my.ActivitySegment = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;

        me.init = function () {};

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
